module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "5px",
      "max-width": "558px"
    }
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-width": "558px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.conformSend()
      }
    }
  }, [_c('div', {}, [_c('div', {}, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nofields),
      expression: "nofields"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  The following fields are required Name, Email Address and\n                  Profession\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successmessage),
      expression: "successmessage"
    }],
    staticClass: "alert alert-success",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                  Thank you for contacting us\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errormessage),
      expression: "errormessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                  An error occured, please try again later\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.name),
      expression: "contactFormFields.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name *",
      "required": "",
      "minlength": "4"
    },
    domProps: {
      "value": (_vm.contactFormFields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.email),
      expression: "contactFormFields.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email address *",
      "required": "",
      "email": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.profession),
      expression: "contactFormFields.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Profession or Field or Work/Study *",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "profession", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.organization),
      expression: "contactFormFields.organization"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Organization"
    },
    domProps: {
      "value": (_vm.contactFormFields.organization)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "organization", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.category),
      expression: "contactFormFields.category"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.contactFormFields, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Category *")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Suggestions"
    }
  }, [_vm._v("Suggestions")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Complaints"
    }
  }, [_vm._v("Complaints")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ideas"
    }
  }, [_vm._v("Ideas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "General Feedback"
    }
  }, [_vm._v("General Feedback")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.feedback),
      expression: "contactFormFields.feedback"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Type your feedback...",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.contactFormFields.feedback)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "feedback", $event.target.value)
      }
    }
  }, [_vm._v("feedback")])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "animated preFadeInUp fadeInUp",
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": "static/img/ajax-loader.gif"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007d53",
      "color": "white",
      "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.4)",
      "border-color": "#007d53",
      "width": "127.5px",
      "height": "41px"
    }
  }, [_vm._v("\n                    Submit\n                  ")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "14.5px",
      "color": "#232323"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('p', [_vm._v("\n          Welcome to the Multi-Source Data Analytics & Triangulation (MSDAT)\n          "), _c('br'), _vm._v("Platform. The DHPRS Team welcomes your feedback and suggestions.\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "13.5px",
      "color": "#717171",
      "margin-bottom": "15px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n          Please leave us your feedback and we will be in touch soon.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74b88aba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/contact.vue
// module id = 970
// module chunks = 6